import { BaseModel } from './base.model';
import { AnalyticSpecification } from '../interfaces/analytic-specification.interface';

export class Analytic extends BaseModel {
  id: string;
  created: number;
  modified: number;
  specification: AnalyticSpecification;
}
